// extracted by mini-css-extract-plugin
export var sidebar = "sidebar-module--sidebar--eTz7H";
export var sidebar_overlay = "sidebar-module--sidebar_overlay--E7cwl";
export var sidebar_buttonClose = "sidebar-module--sidebar_buttonClose--p9m24";
export var sidebar_content = "sidebar-module--sidebar_content--tL-+R";
export var sidebar_links = "sidebar-module--sidebar_links--Kj8t7";
export var active = "sidebar-module--active--MXp+l";